import { render } from "./NewsView.vue?vue&type=template&id=3665a26e&ts=true"
import script from "./NewsView.vue?vue&type=script&lang=ts"
export * from "./NewsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__